import React, { useState } from 'react'
import cn from 'classnames'
import { isEmpty, map } from 'lodash'
import generateUuid from 'uuid/v4'

import Button from '../../Button'
import RadioSelections from '../RadioSelections'
import BackChevron from '../../BackChevron'
import OrderInformation from './OrderInformation'
import TabOrderItems from '../TabOrderItems'
import SidebarModal from '../../SidebarModal'
import confirmationNotification from '../../../hooks/useConfirmationNotification'
import styles from './Details.module.scss'

const TransferCustomer = ({
  anonSuiteExists,
  className,
  onAddCustomerToSuite,
  currentEventId,
  frozen,
  groupedItems,
  modifiedAt,
  onClose,
  onKeepTabOpen,
  onPayNow,
  orderId,
  orderNumber,
  payment,
  subtotal,
  suiteCustomers,
  suiteInformation,
  history,
  userNotes,
}) => {

  const classNames = cn(styles.details, className)
  const [customerSelected, setCustomerSelected] = useState({})
  const [viewStateIndex, setViewStateIndex] = useState(0)
  const { revenueCenterId } = suiteInformation

  const onTransfer = () => {
    if (!customerSelected) return

    if (customerSelected.name === "Anonymous" && !anonSuiteExists) {
      const newUuid = generateUuid()

      const params = [{
        uuid: newUuid,
        customerId: customerSelected?.uuid,
        standUuid: revenueCenterId,
        salesEventId: currentEventId,
        type: "Customer::StandPreference",
      }]
      onAddCustomerToSuite(params)
    }

    setViewStateIndex(1)
  }

  const formatCustomers = customers => {
    return map(customers, (customer) => ({
      name: customer.customerName,
      uuid: customer.customerId,
    }))
  }

  const selectionData = {
    title: "Select customer for order",
    options: formatCustomers(suiteCustomers),
    selectedOption: customerSelected,
    onSetOption: setCustomerSelected,
  }

  const { title, options, selectedOption, onSetOption } = selectionData

  const viewState = [
    {
      content: <RadioSelections className={classNames} title={title} options={options} selectedOption={selectedOption} onSetOption={onSetOption}/>,
      buttons: [
        <Button className={styles.actionButton} key='transfer-Cancel' onClick={onClose}> Cancel </Button>,
        <Button className={[styles.actionButton, styles.mintGreenHighlight]} key='transfer-Submit' onClick={() => confirmationNotification(onTransfer, frozen)} disabled={isEmpty(customerSelected)}>Transfer</Button>
      ]
    },
    {
      content: <TabOrderItems className={classNames}  items={groupedItems}/>,
      buttons: [
        <Button className={styles.actionButton} key='transfer-KeepTabOpen' onClick={() => onKeepTabOpen(customerSelected.uuid)}> Keep Tab Open </Button>,
        <Button className={[styles.actionButton, styles.mintGreenHighlight]} key='transfer-PayNow' onClick={() => onPayNow(customerSelected.uuid)} disabled={isEmpty(customerSelected)}>Pay Now</Button>
      ]
    }
  ]

  const { content, buttons } = viewState[viewStateIndex]

  return (
    <SidebarModal
      className={classNames}
      leftAccessory={<BackChevron onClick={() => (viewStateIndex ? setViewStateIndex(viewStateIndex - 1) : history?.replace?.(`/tabs/${orderId}/more`))} />}
      onClose={onClose}
      show
      title="Transfer Customer"
    >
      <div className={styles.bodyContainer}>
        <OrderInformation account={suiteInformation?.displayName} payment={payment} amount={subtotal} modifiedAt={modifiedAt} orderNumber={orderNumber} note={userNotes} />
        {content}
        <div className={styles.buttonContainer}>
          {buttons}
        </div>
      </div>
    </SidebarModal>
    )
}

export default TransferCustomer
